<template>
  <div >
    <el-form :model="addNewUserForm" ref="addNewUserForm" :rules="rules">
      <el-form-item label="User Name" prop="username" required >
        <el-input v-model="addNewUserForm.username" required :disabled="disabled"></el-input>
      </el-form-item>
      <el-form-item label="User Type" prop="userType" required>
        <el-select v-model="addNewUserForm.userType" >
          <el-option 
            v-for="item in userTypeOption"
            :key="item.id"
            :label="item.name"
            :value="item.name">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Email" prop="email" >
        <el-input v-model="addNewUserForm.email" :disabled="disabled"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('addNewUserForm')">Sure</el-button>
        <!--<el-button @click="resetForm('addNewUserForm')">Reset</el-button>-->
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
    export default {
      name: "addNewUser",
      props:{
        isAddNewUser:{
          type:Boolean,
          default:false
        },
        isEdit:{
          type:Boolean,
          default:false
        },
        editUserInfo:{
          type:Object,
          default:false
        }
      },
      data(){
        //IP验证
        let validateIP = (rule, value, callback) => {
          var reg = /(?=(\b|\D))(((\d{1,2})|(1\d{1,2})|(2[0-4]\d)|(25[0-5]))\.){3}((\d{1,2})|(1\d{1,2})|(2[0-4]\d)|(25[0-5]))(?=(\b|\D))/
          if (value === '') {
            callback(new Error('请输入IP'));
          } else if (!reg.test(value)) {
            callback(new Error('IP不符合规范'));
          }else{
            callback();
          }
        };
         //Telephone验证
        let validateTelephone = (rule, value, callback) => {
          var reg = /^[1][3,4,5,7,8][0-9]{9}$/;
          if (value === '') {
            callback();
          } else if (!reg.test(value)) {
            callback(new Error('Telephone不符合规范'));
          }else{
            callback();
          }
        };
        return {
          addNewUserForm:{
            username:'',
            userType:'user',
            organization:'',
            department:'',
            email:''
          },
          dialogTitle:"Add New User",
          rules: {
            email: [
              { type: 'email',message:'Please enter the correct email address' ,trigger: ['blur','change'] },
            ],
            telephone:[{validator: validateTelephone, trigger: 'blur'}]
          },
          userTypeOption:[],
          disabled:true
        }
      },
      mounted(){
         this.query();
         if(this.isEdit && this.editUserInfo  && JSON.stringify(this.editUserInfo) !== '{}'){
           this.dialogTitle = "Edit User";
           this.addNewUserForm = Object.assign({},this.editUserInfo,{userType:this.editUserInfo.role.name});
         }
      },
      methods:{
        submitForm(formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              if(this.isEdit){
                this.$axios.post('/hlsTS/hlsii/admin/changeUserType/'+ this.editUserInfo.id + '/'+ this.addNewUserForm.userType).then((response) => {
                  if(response.data.success== true){ 
                    this.$message(response.data.message);
                  }else{
                    this.$message('Operation failed');
                  }
                })
              }
              this.$emit('changeToList')
            } else {
              console.log('error submit!!');
              return false;
            }
          });
        },
        resetForm(formName) {
          let defaultUserForm = {
            username:'',
            userType:'user',
            organization:'',
            department:'',
            email:''
          }
          if(this.isEdit){
            this.addNewUserForm = Object.assign({},defaultUserForm,{username:this.addNewUserForm.username});
          }else{
            this.addNewUserForm = Object.assign({},defaultUserForm);
          }
        },
        query(){
           this.$axios({ 
                method:'get',
                url:'/hlsTS/hlsii/admin/getAllRoleInfo'
              }).then((response) => {
                let data = response.data;
                this.userTypeOption = data
            })
        }
      }
    }

</script>

<style>
  .el-table .warning-row {
    background: oldlace;
  }
  .el-table .success-row {
    background: #f0f9eb;
  }
  .userManagement .el-form-item__label{width:110px;}
  .userManagement .el-form-item__content{margin-left:110px}
  .userManagement .el-select{width:100%;}
</style>



// WEBPACK FOOTER //
// src/page/activePublic/userManagement/addNewUserDialog.vue